// extracted by mini-css-extract-plugin
export default {"container":"AdministrationOption_container__RiBiG","logo":"AdministrationOption_logo__CQtpr","disabled":"AdministrationOption_disabled__E+HTg"};